// extracted by mini-css-extract-plugin
export default {"wrapper":"QuickEditButtons_wrapper__BUTYb"};